import { useState, useEffect } from "react";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { ExitIntentHeader } from "./exit-intent/ExitIntentHeader";
import { UserTypeSelector } from "./exit-intent/UserTypeSelector";
import { ExitIntentForm } from "./exit-intent/ExitIntentForm";

export const ExitIntentPopup = () => {
  const [open, setOpen] = useState(false);
  const [isPro, setIsPro] = useState(true);
  const [hasShownPopup, setHasShownPopup] = useState(false);

  useEffect(() => {
    const hasSubscribed = localStorage.getItem("hasSubscribed") === "true";
    let timeoutId: NodeJS.Timeout;
    
    const handleMouseLeave = (e: MouseEvent) => {
      if (
        e.clientY <= 0 && 
        !hasSubscribed && 
        !hasShownPopup && 
        document.documentElement.scrollTop > 300 // User has scrolled at least 300px
      ) {
        timeoutId = setTimeout(() => {
          setOpen(true);
          setHasShownPopup(true);
        }, 2000); // 2 seconds delay before showing popup
      }
    };

    if (!hasSubscribed) {
      // Wait 30 seconds before adding the mouse leave listener
      const initialDelay = setTimeout(() => {
        document.addEventListener("mouseleave", handleMouseLeave);
      }, 30000);

      return () => {
        clearTimeout(initialDelay);
        clearTimeout(timeoutId);
        document.removeEventListener("mouseleave", handleMouseLeave);
      };
    }
  }, [hasShownPopup]);

  const handleSuccess = () => {
    localStorage.setItem("hasSubscribed", "true");
    setOpen(false);
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="sm:max-w-[425px]">
        <ExitIntentHeader />
        <UserTypeSelector isPro={isPro} onProChange={setIsPro} />
        <ExitIntentForm isPro={isPro} onSuccess={handleSuccess} />
        
        <button
          onClick={() => setOpen(false)}
          className="text-sm text-gray-500 hover:text-gray-700 transition-colors"
        >
          Non merci, je préfère le néant
        </button>

        <p className="text-xs text-gray-400">
          Promis, pas de frometon... Enfin, si vous insistez. 🧀
        </p>
      </DialogContent>
    </Dialog>
  );
};